import { MUIDataType } from '@thought-river/negotiations-common/dist/api/contractContent';
import { getGridDefaultColumnTypes } from '@mui/x-data-grid-premium';
import { removeHtmlTags } from '@modules/common/helpers';
import {
    GridCellParams,
    GridFilterOperator,
    getGridStringOperators,
} from '@mui/x-data-grid-premium';

export const getHtmlFilterOperators = () => {
    const defaultOperators = getGridStringOperators().reduce<
        GridFilterOperator[]
    >((operators, operator) => {
        if (operator.value === 'contains') {
            operators.push(operator);
        } else if (operator.value === 'isEmpty') {
            operators.push({
                ...operator,
                getApplyFilterFn: () => (params: GridCellParams) =>
                    !params.value ||
                    removeHtmlTags(String(params.value)).trim() === '',
            });
        } else if (operator.value === 'isNotEmpty') {
            operators.push({
                ...operator,
                getApplyFilterFn: () => (params: GridCellParams) =>
                    !!params.value &&
                    removeHtmlTags(String(params.value)).trim() !== '',
            });
        }

        return operators;
    }, []);

    return defaultOperators;
};

export const getDefaultFilterOperators = (columnType: MUIDataType | 'html') => {
    if (columnType === 'html') {
        return getHtmlFilterOperators();
    }

    return getGridDefaultColumnTypes()[columnType].filterOperators;
};
